"use strict";

exports.__esModule = true;
exports.default = void 0;
var _useEventCallback = _interopRequireDefault(require("@restart/hooks/useEventCallback"));
var _useMergedRefs = _interopRequireDefault(require("@restart/hooks/useMergedRefs"));
var _react = require("react");
var _utils = require("./utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function NoopTransition(_ref) {
  var children = _ref.children,
    inProp = _ref.in,
    onExited = _ref.onExited,
    mountOnEnter = _ref.mountOnEnter,
    unmountOnExit = _ref.unmountOnExit;
  var ref = (0, _react.useRef)(null);
  var hasEnteredRef = (0, _react.useRef)(inProp);
  var handleExited = (0, _useEventCallback.default)(onExited);
  (0, _react.useEffect)(function () {
    if (inProp) hasEnteredRef.current = true;else {
      handleExited(ref.current);
    }
  }, [inProp, handleExited]);
  var combinedRef = (0, _useMergedRefs.default)(ref, (0, _utils.getChildRef)(children));
  var child = /*#__PURE__*/(0, _react.cloneElement)(children, {
    ref: combinedRef
  });
  if (inProp) return child;
  if (unmountOnExit) {
    return null;
  }
  if (!hasEnteredRef.current && mountOnEnter) {
    return null;
  }
  return child;
}
var _default = exports.default = NoopTransition;